
export default [
  {
    path: '/',
    name: 'home',
    component: () => import('@/modules/dashboard/Index'),
  }
];